var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var PageModules = require('./lib/page-modules.js');
var Parallax = require('./lib/parallax.js');
var SVGShapes = require('./lib/svg-shapes.js');
var TextEffects = require('./lib/text-effects.js');
var ScrollEvents = require('./lib/scroll-events.js');
var LoadImages = require('./lib/load-images.js');
var FormTooltip = require('./lib/form-tooltip.js');
var FormError = require('./lib/form-error.js');
// var AJAXLoad = require('./lib/ajax-load.js');

(function() {
  // $('body').on('click', 'a[href^="'+SiteVars['home_url']+'"]', AJAXLoad);

  window.gtmTrackEvent = function(data) {
    if(typeof window.dataLayer === 'undefined') {
      console.log(data);
    } else {
      window.dataLayer.push(data);
    }
  };

  if ( location.hash ) {
    var $target = $( location.hash ),
        offset = $target.position().top - 69;

    $(window).on('load', function() {
      $('main').scrollTop(offset);
    });
  };

  var Site = {
    modules: new PageModules(),
    parallax: new Parallax(),
    scroll: new ScrollEvents(),
    shapes: new SVGShapes(),
    text: new TextEffects(),
    loadImages: new LoadImages(),
    formTooltip: new FormTooltip(),
    formError: new FormError()
  };

  $('.menu-bacon').toggleClass('menu-sausage', Math.random() > 0.5);

  $('body').addClass('ready');

  $(window).on('vsc-page-changed', function() {
    Site.modules.init();
    Site.parallax.init();
    Site.scroll.init();
    Site.shapes.init();
    Site.text.init();
    Site.loadImages.init();
    Site.formTooltip.init();
  });

  $(window).trigger('vsc-page-ready');

  var isAtLeastIE11 = !!(navigator.userAgent.match(/Trident/) && !navigator.userAgent.match(/MSIE/));

  if (isAtLeastIE11) {
    $('html').addClass('ie');
  }

})();
